import { type Filter } from '../../_types/Car';
import { Modules } from '../_definition/types';

export const fahrzeugsucheModuleName = Modules?.Fahrzeugsuche;

export type FahrzeugsucheFilterForm = Filter & { afterSubmit?: string };
